import { l as n } from "../transform-DVGbLiBW.js";
import "../type-Dku6Xzl6.js";
function c(e) {
  const r = Object.keys({
    className: !0,
    containerRef: !0,
    inputSectionRef: !0,
    label: !0,
    labelClassName: !0,
    icons: !0,
    input: !0,
    actions: !0,
    hint: !0,
    error: !0,
    errorOnTooltip: !0,
    disabled: !0,
    readOnly: !0,
    prevValue: !0,
    withPrevValue: !0,
    highlightMode: !0,
    required: !0,
    variant: !0,
    withAsterisk: !0,
    spacing: !0,
    withBackground: !0,
    withDarkBackground: !0,
    withPadding: !0,
    withoutInputSectionPadding: !0
  }), i = n(
    r,
    (t) => t,
    (t) => e[t]
  ), u = {
    ...e
  };
  return r.forEach((t) => {
    delete u[t];
  }), [i, u];
}
export {
  c as extractInputContainerProps
};
